import React from "react";
import { StatsCard } from "tabler-react";

export default function AnalyticsStatsCards({ dashboardData }) {
  const data = dashboardData || {};

  return (
    <div className="box_flex_container">
      <div className="box1_flex">
        <div className="card card101">
          <div className="card-body text-center">
            <StatsCard
              layout={1}
              movement={data.allUsersPercentageChange}
              total={data.todayUsers}
              label="Total Users"
            />
          </div>
        </div>
      </div>
      <div className="box1_flex">
        <div className="card card101">
          <div className="card-body text-center">
            <StatsCard
              layout={1}
              movement={data.uniqueUsersPercentageChange}
              total={data.todayUniqueUsers}
              label="Total Unique Users"
            />
          </div>
        </div>
      </div>
      <div className="box1_flex">
        <div className="card card101">
          <div className="card-body p-3 text-center">
            <StatsCard
              layout={1}
              movement={data.completedFlowPercentageChange}
              total={data.todayCompletedFlow}
              label="Completed Flows"
            />
          </div>
        </div>
      </div>
      <div className="box1_flex">
        <div className="card card101">
          <div className="card-body p-3 text-center">
            <StatsCard
              layout={1}
              movement={data.inCompletedFlowPercentageChange}
              total={data.todayInCompletedFlow}
              label="Incomplete Flows"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
